/**
 * Parses the shared Crystallize `element-styling` piece into a plain color object.
 *
 * The same component shape is reused across features (Installation Check promo slots, the global
 * top banner), so the parser lives here at the Crystallize integration layer rather than inside any
 * single feature. Values may come from a Single line `text` (arbitrary hex) or a Selection option.
 */
export type ElementStyling = {
  backgroundColor?: string;
  textColor?: string;
  buttonColor?: string;
  headlineColor?: string;
  footnoteColor?: string;
};

export function extractElementStyling(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parsedComponents: Record<string, any>,
): ElementStyling {
  const stylingPiece =
    parsedComponents['element-styling'] || parsedComponents['promotion-element-styling'];

  if (!stylingPiece?.components) {
    return {};
  }

  const styling: ElementStyling = {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  stylingPiece.components.forEach((comp: any) => {
    const value = comp?.content?.text || comp?.content?.options?.[0]?.value;
    if (!value) {
      return;
    }

    switch (comp.id) {
      case 'background-color':
        styling.backgroundColor = value;
        break;
      case 'text-color':
        styling.textColor = value;
        break;
      case 'button-color':
        styling.buttonColor = value;
        break;
      case 'headline-color':
        styling.headlineColor = value;
        break;
      case 'footnote-color':
        styling.footnoteColor = value;
        break;
      default:
        break;
    }
  });

  return styling;
}
